import { createContext } from "react";
import _ from "lodash";

export const STORAGE_KEY_STORED_LOCALE = "locale/storedLocale";

export type LocaleContextType = {
    setLocale: (x: Locales) => any;
    locale: Locales;
};

export enum Locales {
    EN_US = "en-US",
    ES = "es",
}

export const supportedLocales = [Locales.EN_US, Locales.ES];

export const getBestLocale = lang => {
    // exact match
    if (supportedLocales.indexOf(lang) > -1) {
        return supportedLocales[supportedLocales.indexOf(lang)];
    }
    // matching language
    return (
        supportedLocales.find(loc => loc.indexOf(lang) === 0) || Locales.EN_US
    );
};

/**
 * Create a default Locale Context
 *
 * Apps extending these modules can implement setLocale
 * to change the current locale
 *
 *
 */
export const defaultLocale: LocaleContextType = {
    setLocale: () => {}, // noop default
    // locale: Locales.ES, // debug
    locale: Locales.EN_US,
};

export const LocaleContext = createContext(defaultLocale);

export const getLocale = (country: string, lang: string) =>
    `${lang.toLocaleLowerCase()}-${country.toUpperCase()}`;

export const getGlobalLanguageFlag = (lang: string) =>
    `LANG_${lang.toLocaleUpperCase()}`;

export const getGlobalCountryFlag = (country: string) =>
    `COUNTRY_${country.toLocaleUpperCase()}`;

// create a token replacer template function
type TemplateFunction = (values: object) => string;
type TemplateGenerator = (template: string) => TemplateFunction;

export const template: TemplateGenerator = template => {
    _.templateSettings.interpolate = /\{\{([\s\S]+?)\}\}/g;
    return _.template(template);
};

export default {
    defaultLocale,
    LocaleContext,
    getLocale,
    getGlobalLanguageFlag,
    getGlobalCountryFlag,
};
